import type { NegociacaoSimulacaoState, RecusaDoAvanco, BuilderDaSimulacao } from '../../types';
import { avancoFalhouDepoisDeAndar } from '../../utils/avancoDoRelogio';
import { desfechoDesconhecido } from '../../utils/intencaoDeComando';
import { progressoDoAvancoRecebido } from '../eventosDoStore';
import { avancarRelogioDaSimulacao, continuarAvancoDoRelogio } from './actions';

const fimDoAvanco = (state: NegociacaoSimulacaoState, simulacaoId: string, pendentes: number) => {
  if (state.simulacao?.id !== simulacaoId) return;
  state.avancando = false;
  state.pendentesDoAvanco = pendentes;
};

/** Recusa sem `simulacaoId` não veio do `rejectWithValue`: o avanço da tela não pode ficar preso. */
const avancoDaSimulacaoAtual = (state: NegociacaoSimulacaoState, simulacaoId: string | undefined) =>
  simulacaoId === undefined || state.simulacao?.id === simulacaoId;

/** Chave usada e de desfecho conhecido não serve a mais nada (CA-17). */
const descartarChavesDoAvanco = (state: NegociacaoSimulacaoState) => {
  delete state.intencoes.avancarRelogio;
  delete state.intencoes.processarVencimentos;
};

const iniciarAvanco = (state: NegociacaoSimulacaoState) => {
  state.avancando = true;
  state.erroDoAvanco = null;
};

const recusarAvanco = (state: NegociacaoSimulacaoState, action: RecusaDoAvanco) => {
  if (!avancoDaSimulacaoAtual(state, action.meta.simulacaoId)) return;
  state.avancando = false;
  state.erroDoAvanco = action.payload ?? null;
  if (!desfechoDesconhecido(state.erroDoAvanco)) descartarChavesDoAvanco(state);
  // O "Tentar novamente" da continuação é o retry que não soma o tempo de novo.
  if (avancoFalhouDepoisDeAndar(state.erroDoAvanco)) {
    state.pendentesDoAvanco = Math.max(state.pendentesDoAvanco, 1);
  }
};

export function registrarAvancoDoRelogio(builder: BuilderDaSimulacao): void {
  builder
    // As chaves na tela são da simulação atual: o passo tardio de uma reiniciada não as apaga.
    .addCase(progressoDoAvancoRecebido, (state, action) => {
      if (state.simulacao?.id !== action.payload.simulacaoId) return;
      descartarChavesDoAvanco(state);
      state.simulacao = action.payload.estado;
      state.pendentesDoAvanco = action.payload.pendentes;
    })
    .addCase(avancarRelogioDaSimulacao.fulfilled, (state, action) => {
      fimDoAvanco(state, action.payload.simulacaoId, action.payload.pendentes);
    })
    .addCase(continuarAvancoDoRelogio.fulfilled, (state, action) => {
      fimDoAvanco(state, action.payload.simulacaoId, action.payload.pendentes);
    })
    .addCase(avancarRelogioDaSimulacao.pending, iniciarAvanco)
    .addCase(continuarAvancoDoRelogio.pending, iniciarAvanco)
    .addCase(avancarRelogioDaSimulacao.rejected, recusarAvanco)
    .addCase(continuarAvancoDoRelogio.rejected, recusarAvanco);
}
